import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

import Layout from '../layout'

export const constantRoutes = [
  {
    path: '/404',
    component: () => import('@/components/404'),
    meta: { title: '404' },
    hidden: true
  },
  {
    path: '/login',
    component: () => import('@/modules/officialAccounts/pages/login/index'),
    meta: { title: '登录' }
  },
  {
    path: '/',
    component: Layout,
    redirect: '/app',
    children: [
      {
        path: '/app',
        name: 'App',
        component: () => import('@/modules/officialAccounts/pages/app'),
        meta: { title: '应用中心' }
      }, {
        path: '/user',
        name: 'User',
        component: () => import('@/modules/officialAccounts/pages/user'),
        meta: { title: '我的' }
      }]
  },
  { path: '*', redirect: '/404', hidden: true }
]

const createRouter = () => new Router({
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes
})

const router = createRouter()

export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher
}

router.beforeEach((to, from, next) => {
  document.title = `${to.meta.title}`
  next()
})

export default router
